/**
 * Created by portiz on 5/13/19.
 */
import React from 'react';
import {Media, Card, CardBody, Col, Button, Form, FormGroup, Input} from 'reactstrap';
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEnvelope} from '@fortawesome/free-solid-svg-icons';

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../translations/global.json"
import LanguageToggle from "./selectors/language-selector";
/** End of Multiple Language imports **/

import LanguageManager from '../custom-classes/language-manager';
import FromGroupNewPassword from './forms/form-group-new-password';
import ApiCalls from  '../custom-classes/api-calls';

import LoaderFullWindow from './loader-windows/loader-full-window';
import ModalGeneric from './modals/modal-generic';

import queryString from 'query-string';

/**
 * The component (window) to reset the password
 */
class AccountAccessRecovery extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        // To support language library add the following lines
        this.props.initialize({
            languages: [
                {name: "English", code: "en"},
                {name: "Español", code: "es"}
            ],
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage()}
        });
        this.state = {
            password: '',
            validPassword: false,
            token: null,
            loading: false,
            propsModal: null,
            showModal: false
        };
        this.props.addTranslation(global);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePasswordInput = this.handlePasswordInput.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
    }

    componentDidMount(){
        const values = queryString.parse(this.props.location.search);
        this.setState({
            token: values.token
        });
    }

    /**
     * Hide or shows alert modal.
     */
    toggleAlertModal(){
        this.setState({showModal: false});
    }
    /**
     * Renders the generic modal used for messages
     * @returns {XML} Returns the component.
     */
    renderGenericModal() {
        return (
            <ModalGeneric data={this.state.propsModal} updateParent={this.toggleAlertModal}/>
        );
    }

    /**
     * Handle the reset password submition.
     */
    handleSubmit() {
        this.setState({loading: true}, ()=> {
            let apiCall = ApiCalls.callPasswordResetNewPassword(this.state.token, this.state.password, this.state.password);
            apiCall.then((returned)=> {
                let propsModal = {
                    bodyText: returned.Messages[0],
                    visible: true
                };
                this.setState({propsModal: propsModal, showModal: true, loading: false});
            });
        });
    }

    /**
     * Handles when the user inputs the email
     * @param e
     */
    handlePasswordInput(e) {
        this.setState({
            validPassword: e.validPassword,
            password: e.password
        });
    }

    /**
     * Renders the main form when the user enters the email.
     * @returns {XML}
     */
    renderForm() {
        return <div>
            <Card>
                <CardBody>
                    <FontAwesomeIcon icon={faEnvelope}/>{' '}
                    <Translate id="password-reset.enter-email"/>
                </CardBody>
                <CardBody>
                    <Form>
                        <FormGroup row>
                            <Col sm={{size: 10, offset: 1}}>
                                <FromGroupNewPassword isForPasswordReset={true} updateParent={this.handlePasswordInput}/>
                            </Col>
                        </FormGroup>

                        <FormGroup row>
                            <Col sm={{size: 10, offset: 1}}>
                                <Button color="success" block onClick={this.handleSubmit}
                                        disabled={!this.state.validPassword}>
                                    <Translate id="general.submit"/>
                                </Button>
                            </Col>
                        </FormGroup>

                        <FormGroup row>
                            <Col sm={{size: 10, offset: 1}}>
                                <Link to="/login" className="btn btn-info btn-block">
                                    <Translate id="password-reset.go-back-to-login"/>
                                </Link>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col sm={{size: 10, offset: 1}}>
                                <LanguageToggle/>
                            </Col>
                        </FormGroup>
                    </Form>
                </CardBody>
            </Card>
        </div>;
    };

    /**
     * Renders the main form
     * @returns {XML} Returns the component.
     */
    render() {
        return (
            <div>
                <Col xs={{size: 4, offset: 4}} lg={{size: 2, offset: 5}}>
                    <Media src={require('../img/user-icon-5.png')} alt="User icon" width="100%"/>
                </Col>
                <Col sm={{size: 8, offset: 2}} lg={{size: 6, offset: 3}}>
                    {this.renderForm()}
                </Col>
                <Col xs={{size: 4, offset: 4}} lg={{size: 2, offset: 5}}>
                    <Media src={require('../img/logo.png')} alt="Company logo" width="100%"/>
                </Col>
                {this.state.loading ? <LoaderFullWindow/> : null}
                {this.state.showModal ? this.renderGenericModal() : null}
            </div>
        )
    };
}

export default withLocalize(AccountAccessRecovery); // withLocaliza is added to support language. Else, don't add it.